import React from 'react';
import { Yard } from '../../../types/stock.types';

interface Props {
    managers: Yard['managers'];
}

/**
 * A yard's managers, as shown in list rows.
 *
 * Managers come from membership (§5.4), so unlike the old single FK there can be none
 * or several. Names are alphabetical from the server; only the first is shown with a
 * "+n" for the rest, because the column has to stay one line wide — the full list is in
 * the title attribute and on the Manage Yard page.
 */
export const YardManagers: React.FC<Props> = ({ managers }) => {
    const list = managers ?? [];

    // Predates the "every yard needs a manager" rule, or the last one was removed.
    if (list.length === 0) return <span className="text-muted-foreground">–</span>;

    return (
        <span title={list.map((m) => m.name).join(', ')}>
            {list[0].name}
            {list.length > 1 && (
                <span className="text-muted-foreground"> +{list.length - 1}</span>
            )}
        </span>
    );
};

export default YardManagers;
